<template>
  <v-app-bar flat fixed dark class="home-header" color="primary">
    <v-spacer></v-spacer>
    <router-link to="/inicio" class="mt-4" link>
      <v-img
        :src="require('@/assets/' + logoAsset)"
        max-height="120"
        max-width="120"
        class="mt-12"
        contain
      ></v-img>
    </router-link>
    <v-spacer></v-spacer>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text depressed>
          <span class="header-font">
            <b>
              Home
              <v-icon>{{ icons.menuDown }}</v-icon>
            </b>
          </span>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          class="pointer"
          v-for="(item, index) in publicHeaderItems"
          :key="index"
          :to="item.path"
        >
          <v-list-item-title class="tiny-font">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-spacer v-if="userType === 'cliente'"></v-spacer>
    <template v-if="userType === 'cliente'">
      <v-btn
        :to="{ path: '/agendamento' }"
        text
        depressed
        active-class="highlighted"
      >
        <span class="header-font">
          <b>Agendar Serviço</b>
        </span>
      </v-btn>
    </template>
    <v-spacer></v-spacer>

    <v-btn
      :to="{ path: '/mensagens' }"
      text
      depressed
      active-class="highlighted"
    >
      <span class="header-font">
        <template v-if="messageCount > 0">
          <v-badge color="secondary" :content="messageCount" class="pr-2">
            <b>Mensagens</b>
          </v-badge>
        </template>
        <template v-else>
          <b>Mensagens</b>
        </template>
      </span>
    </v-btn>

    <v-spacer v-if="userType === 'profissional'"></v-spacer>
    <template v-if="userType === 'profissional'">
      <v-btn
        :to="{ path: '/prontuarios_pendentes' }"
        text
        depressed
        active-class="highlighted"
      >
        <span class="header-font">
          <b>Prontuários pendentes</b>
        </span>
      </v-btn>
    </template>

    <v-spacer v-if="userType === 'cliente'"></v-spacer>
    <template v-if="userType === 'cliente'">
      <v-btn
        :to="{ path: '/prontuarios_pendentes' }"
        text
        depressed
        active-class="highlighted"
      >
        <span class="header-font">
          <b>Prontuários</b>
        </span>
      </v-btn>
    </template>
    <!--
    <v-spacer v-if="userType === 'cliente'"></v-spacer>
    <template v-if="userType === 'cliente'">
      <v-btn
        :to="{ path: '/armazenamento' }"
        text
        depressed
        active-class="highlighted"
      >
        <span class="header-font">
          <b>Armazenamento</b>
        </span>
      </v-btn>
    </template>
    -->
    <v-spacer v-if="userType === 'profissional'"></v-spacer>
    <template v-if="userType === 'profissional'">
      <v-btn
        :to="{ path: '/informacao_atendimento' }"
        text
        depressed
        active-class="highlighted"
      >
        <span class="header-font">
          <b>Informações de Atendimento</b>
        </span>
      </v-btn>
    </template>

    <v-spacer></v-spacer>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text depressed>
          <span class="header-font">
            <b>
              Agendamentos
              <v-icon>{{ icons.menuDown }}</v-icon>
            </b>
          </span>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          class="pointer"
          v-for="(item, index) in this.$store.getters.getUserType ===
          'profissional'
            ? itemsProfissional
            : items"
          :key="index"
          :to="item.path"
        >
          <v-list-item-title class="tiny-font">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-spacer></v-spacer>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text depressed>
          <v-avatar size="36px">
            <img alt="Avatar" :src="avatar" />
          </v-avatar>
          <span class="header-font pl-2">
            <b>
              Meu Perfil
              <v-icon>{{ icons.menuDown }}</v-icon>
            </b>
          </span>
        </v-btn>
      </template>
      <PerfilMenu />
    </v-menu>
    <v-spacer></v-spacer>
  </v-app-bar>
</template>
<script>
import PerfilMenu from '@/components/menus/PerfilMenu.vue'
import { mdiMenuDown } from '@mdi/js'
export default {
  name: 'HomeHeaderUser',
  components: { PerfilMenu },
  data: () => ({
    icons: {
      menuDown: mdiMenuDown
    },
    publicHeaderItems: [
      { title: 'Página Inicial', path: '/' },
      //{ title: "Funcionalidades", path: "/services" },
      { title: 'Vantagens', path: '/vantagens' },
      { title: 'Serviços', path: '/saibamais' },
      { title: 'Sobre nós', path: '/sobre' },
      { title: 'Contato', path: '/contato' },
      { title: 'Perguntas Frequentes', path: '/faq' },
      { title: 'Para sua Empresa', path: '/contatoEmpresa' }
    ],
    items: [
      { title: 'Realizados', path: '/agendamentos_realizados' },
      { title: 'Programados', path: '/atendimentos_agendados' }
    ],
    itemsProfissional: [
      { title: 'Realizados', path: '/servicos_realizados' },
      { title: 'Programados', path: '/atendimentos_agendados' }
    ],
    itemsPerfil: [
      { title: 'Trocar Perfil', path: '/selecionarperfil' },
      { title: 'Editar Perfil', path: '/perfil' },
      { title: 'Sair', path: '/' }
    ]
  }),
  computed: {
    userType: function() {
      return this.$store.getters.getUserType
    },
    messageCount: function() {
      return this.$store.getters.getMessageCount
    },
    perfil: function() {
      return this.$store.getters.getPerfil
    },
    avatar: function() {
      return this.perfil.foto_perfil && this.perfil.foto_perfil.length > 0
        ? this.perfil.foto_perfil
        : require('@/assets/img/without_image.png')
    },
    logoAsset() {
      return process.env.VUE_APP_INSTA_LOGO
    }
  },
  methods: {
    processHeaderLink(item) {
      switch (item.title) {
        case 'Sair':
          this.$store.dispatch('logout', { redirect: true })
          break
        case 'Trocar Perfil':
          this.$store.getters.getAccountType === 'profissional'
            ? this.$router.push('/signin')
            : this.$router.push(item.path)
          break
        default:
          this.$router.push(item.path)
      }
    }
  },

  mounted() {}
}
</script>

<style scoped>
.highlighted span {
  font-size: 14px;
  font-weight: bold;
}

.v-btn--active {
  opacity: 1 !important;
}

.tiny-font {
  font-size: 13px;
}

.pointer:hover {
  cursor: pointer;
}

.v-application a {
  text-decoration: none;
  color: unset;
}

.home-header {
  z-index: 99;
}
</style>
